import { render, staticRenderFns } from "./SecureChatPatient.vue?vue&type=template&id=23448772&scoped=true"
import script from "./SecureChatPatient.vue?vue&type=script&lang=js"
export * from "./SecureChatPatient.vue?vue&type=script&lang=js"
import style0 from "./SecureChatPatient.vue?vue&type=style&index=0&id=23448772&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23448772",
  null
  
)

export default component.exports